import { Card } from "@/components/portal/ui";

export function StatCard({ label, value, icon: Icon, accent, testid, delay = 0 }) {
  return (
    <Card
      data-testid={testid}
      className="p-5 kw-fade-up"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.16em]" style={{ color: "var(--text-muted)" }}>
            {label}
          </div>
          <div className="mt-2 text-3xl font-heading font-bold" style={{ color: "var(--text)" }}>
            {value}
          </div>
        </div>
        {Icon && (
          <div
            className="h-10 w-10 flex items-center justify-center shrink-0"
            style={{
              background: accent ? "var(--accent)" : "var(--surface-alt)",
              color: accent ? "var(--accent-fg)" : "var(--text-muted)",
              borderRadius: "var(--radius)",
            }}
          >
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </Card>
  );
}
